/**
 * Copyright © 2026 Adnuntius AS.
 */
import {
  AfterViewInit,
  Component,
  ElementRef,
  Inject,
  Input,
  OnChanges,
  ViewChild,
  signal
} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import template from './layout-example-edit-page.component.html';

import {setupLayoutExamplePreview, translateLayoutComponentMediaTypes} from './layout-example-commons';
import {WINDOW} from '../../angular-platform-providers';
import {APP_SHARED} from '../../common/app-shared';
import {CodemirrorFieldComponent} from '../../common/directives/codemirror-field.component';

@Component({
  standalone: true,
  imports: [...APP_SHARED, CodemirrorFieldComponent],
  selector: 'adn-layout-example-edit-page',
  template
})
export class LayoutExampleEditPageComponent implements OnChanges, AfterViewInit {
  @Input() model: any;
  @Input() isNew: boolean;

  private readonly codemirrorReadyState = signal(false);
  get codemirrorReady(): boolean { return this.codemirrorReadyState(); }
  set codemirrorReady(value: boolean) { this.codemirrorReadyState.set(value); }
  private previewInitialized = false;

  @ViewChild('iframeContainer') iframeContainer: ElementRef<HTMLDivElement>;

  constructor(
    @Inject(WINDOW) private window: any,
    private translate: TranslateService
  ) {
  }

  ngOnChanges(): void {
    if (this.model) {
      this.codemirrorReady = true;
      this.initPreview();
    }
  }

  ngAfterViewInit(): void {
    this.initPreview();
  }

  mediaTypesLabel(mimeTypes: string | string[]): string {
    return translateLayoutComponentMediaTypes(mimeTypes, (key) => this.translate.instant(key));
  }

  private initPreview(): void {
    if (this.previewInitialized || !this.model || !this.iframeContainer) {
      return;
    }
    this.previewInitialized = true;
    setTimeout(() => {
      setupLayoutExamplePreview(
        this.model,
        this.iframeContainer.nativeElement,
        this.window
      );
    }, 20);
  }
}
